import { Button } from 'semantic-ui-react';

export const marryInComunidadRequirements = (flags) => {
  return (
    <>
      <h3>Requisitos Para Casarse en Comunidad:</h3>
      <ul>
        <li>{!!flags && <span>{flags?.Group ? '✅' : '❌'}</span>} Estar en un grupo </li>
        <li>
          {!!flags && <span>{flags?.ProyectoMatrimonio >= 80 ? '✅' : '❌'}</span>} Haber hecho
          proyecto M (hace máximo 2 años)
        </li>
        <li>Contar con 3 meses de anticipación</li>
      </ul>
    </>
  );
};

const StepChecks = (props) => {
  const { inputs, setStep } = props;
  const { flags } = inputs;

  const ableToContinue = flags?.Group && flags?.ProyectoMatrimonio >= 80;

  const handleContinue = () => {
    if (ableToContinue) {
      setStep('step-read-doc');
    } else {
      setStep('not-fulfilled');
    }
  };

  return (
    <div className="marriage-requirements-container">
      <div className="requirements-box">
        <p className="author-note">
          <strong>Felicitaciones por decidir dar este hermoso paso hacia el matrimonio.</strong>
        </p>
        {ableToContinue ? (
          <>
            <p className="author-note">
              Es fundamental comprender lo que significa formar una familia delante de Dios: ambos,
              hombre y mujer, deben ser plenamente conscientes del pacto que están asumiendo; que
              más allá de sus propios anhelos, honrar a Dios, su diseño, amarse y respetarse el uno
              al otro es fundamental. Y saber que el verdadero deleite en el matrimonio, será el
              fruto de una vida íntegra conforme al corazón de Dios y de una familia que glorifica
              el nombre de Jesús en lo íntimo y en lo público.
            </p>

            <p className="author-note">
              En Comunidad, queremos abrazarlos y acompañarlos para que cada paso que den sea
              consciente y genuino, pues creemos en un matrimonio para toda la vida. Por eso, los
              invitamos a revisar cuidadosamente los requisitos para celebrar la ceremonia
              religiosa, e incluso considerar esperar a cumplir con los procesos antes de avanzar
              hacia el matrimonio civil, pagos de salón y envío de invitaciones.
            </p>
            <p className="author-note">
              Para continuar con el proceso de inscripción prematrimonial, es necesario leer con
              atención el documento{' '}
              <strong>"Información Ceremonia Cristiana y Matrimonio Civil"</strong>, y confirmar su
              aceptación de los términos, requisitos y compromisos establecidos.
            </p>
            <p className="author-note">
              Este camino de preparación es un acto de amor, compromiso y fe.
              <p>¡Estamos aquí para acompañarlos en cada paso!</p>
            </p>
          </>
        ) : (
          <p className="author-note">
            <strong>
              Lastimosamente, en el momento no tienes los requisitos para comenzar el proceso de
              solicitud, por favor presiona el botón de abajo para comunicarte con nosotros.
            </strong>
          </p>
        )}
        {marryInComunidadRequirements(flags)}
        <div className="button-container">
          <Button disabled={false} onClick={handleContinue}>
            Continuar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepChecks;
